import React from 'react';
import { MobileDesignConfigView, MobileDesignConfigClasses, MobileDesignConfigState, MobileDesignSection, MobileDesignProduct } from '../MobileDesignConfig.types';
import { MediaConfigState } from '../hooks/useMediaConfig';
import { MediaSection } from './MediaSection';
import { TextSection } from './TextSection';
import { ProductSection } from './ProductSection';
import { LinkSection } from './LinkSection';

interface DesignContentProps {
  view: MobileDesignConfigView;
  classes: MobileDesignConfigClasses;
  state: MobileDesignConfigState;
  mediaState?: MediaConfigState;
  sections: MobileDesignSection[];
  searchTerm: string;
  onSliderImageChange: (index: number, image: string) => void;
  onSliderImageRemove: (index: number) => void;
  onDesignImageUpload: (image: string, key: 'fedilityImage' | 'myAccountPicture' | 'myOrdersPicture') => void;
  onDesignImageRemove: (key: 'fedilityImage' | 'myAccountPicture' | 'myOrdersPicture') => void;
  onDisableLoader: () => void;
  onFieldChange: (
    field: 'titleDescription' | 'name' | 'newProductsDescription' | 'clientSpace',
    value: string
  ) => void;
  onResetField: (
    field: 'titleDescription' | 'name' | 'newProductsDescription' | 'clientSpace',
    value: string
  ) => void;
  onLinkChange: (field: 'url', value: string) => void;
  onSocialChange: (field: 'facebook' | 'instagram' | 'linkedin', value: string) => void;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onApplySearch: (term: string) => void;
  onProductCheck: (product: MobileDesignProduct) => void;
}

export const DesignContent: React.FC<DesignContentProps> = ({
  view,
  classes,
  state,
  mediaState,
  sections,
  searchTerm,
  onSliderImageChange,
  onSliderImageRemove,
  onDesignImageUpload,
  onDesignImageRemove,
  onDisableLoader,
  onFieldChange,
  onResetField,
  onLinkChange,
  onSocialChange,
  onSearchChange,
  onApplySearch,
  onProductCheck
}) => {
  switch (view) {
    case MobileDesignConfigView.MEDIAS:
      return (
        <MediaSection
          classes={classes}
          state={state}
          mediaState={mediaState}
          onSliderImageChange={onSliderImageChange}
          onSliderImageRemove={onSliderImageRemove}
          onDesignImageUpload={onDesignImageUpload}
          onDesignImageRemove={onDesignImageRemove}
          onDisableLoader={onDisableLoader}
        />
      );
    case MobileDesignConfigView.TEXT:
      return (
        <TextSection
          classes={classes}
          state={state}
          onFieldChange={onFieldChange}
          onReset={onResetField}
        />
      );
    case MobileDesignConfigView.PRODUCTS:
      return (
        <ProductSection
          classes={classes}
          state={state}
          sections={sections}
          searchTerm={searchTerm}
          onSearchChange={onSearchChange}
          onApplySearch={onApplySearch}
          onProductCheck={onProductCheck}
        />
      );
    case MobileDesignConfigView.LINKS:
      return (
        <LinkSection
          classes={classes}
          state={state}
          onLinkChange={onLinkChange}
          onSocialChange={onSocialChange}
        />
      );
    default:
      return null;
  }
};

